import logoMevuelo from './logoMevuelo.svg';
import logoMevueloWhite from './logoMevueloWhite.svg';
import logoQrCode from './qrCode.png';
import logoBancard from './bancard.png';
import logoPci from './pci.png';
import logoSupportAgent from './supportAgent.svg';
import logosSecurityEncryption from './securityEncryption.svg';
import logoWallet from './wallet.svg';
import logoBackPack from './backpack.svg';
import logoBank from './bank.svg';
import logoCard from './card.svg';
import logoCash from './cash.svg';
import logoVisa from './visa.svg';
import logoOca from './oca.svg';
import logoAmerican from './american.svg';
import logoMasterCard from './mastercard.svg';
import fbLoginAsset from './fb_login.png';
import googleLoginAsset from './google_login.png';
import propertyExample from './hotelExampleProperty.svg';
import chatGpt from './logoChatgpt.svg';
import homeBackground from './background.webp';

// icons
import iconArrowDown from './arrowDown.svg';
import iconLanguage from './languageIcon.svg';
import iconDisconnectedUser from './disconnectedUser.svg';
import iconHeart from './heart.svg';
import iconCurrency from './currency.svg';
import iconBell from './bell.svg';
import iconHelp from './help.svg';
import iconTicket from './ticket.svg';
import iconFlame from './flame.svg';
import unionIcon from './Union.svg';
import iconSpain from './iconSpain.svg';
import iconUnitedStates from './iconUnitedStates.svg';
import iconBrazil from './iconBrazil.svg';
import emptyStateImage from './emptyState.svg';
import pdf from './pdf.svg';
import txt from './txt.svg';
import jpg from './jpg.svg';
import xls from './xls.svg';
import png from './png.svg';
import document from './document.svg';
// logos
export const logo = logoMevuelo;
export const logoDesktop = logoMevueloWhite;
export const qrCode = logoQrCode;
export const bancard = logoBancard;
export const pci = logoPci;
export const supportAgent = logoSupportAgent;
export const securityEncryption = logosSecurityEncryption;
export const wallet = logoWallet;
export const backpack = logoBackPack;
export const bank = logoBank;
export const card = logoCard;
export const cash = logoCash;
export const visa = logoVisa;
export const oca = logoOca;
export const american = logoAmerican;
export const mastercard = logoMasterCard;
export const fbLoginIcon = fbLoginAsset;
export const googleLoginIcon = googleLoginAsset;
export const propertyExampleImage = propertyExample;
export const homeBackgroundImage = homeBackground;
export const logoChatGpt = chatGpt;

// icons
export const disconnectedUser = iconDisconnectedUser;
export const arrowDown = iconArrowDown;
export const language = iconLanguage;
export const heart = iconHeart;
export const currency = iconCurrency;
export const bell = iconBell;
export const help = iconHelp;
export const ticket = iconTicket;
export const flame = iconFlame;
export const unionArrow = unionIcon;
export const flagSpain = iconSpain;
export const flagUnitedStates = iconUnitedStates;
export const flagBrazil = iconBrazil;
export const emptyState = emptyStateImage;
export const pdfIcon = pdf;
export const txtIcon = txt;
export const jpgIcon = jpg;
export const xlsIcon = xls;
export const pngIcon = png;
export const documentIcon = document;
